// extracted by mini-css-extract-plugin
export default {"title":"telepon-debitur_title__kmmDY","telepon-debitur-info":"telepon-debitur_telepon-debitur-info__rBBrd"};